import type { ReactNode } from 'react';

/**
 * O corpo de uma tela geral dentro da moldura.
 *
 * Áudio, Máquinas, Contas e Saúde são pilhas de cartões: precisam de margem e
 * de rolagem própria. A tela de trabalho não — o editor ocupa tudo e rola por
 * dentro. Por isso o respiro fica aqui, em quem é tela, e não no centro da
 * moldura, que serve aos dois.
 */
export function Tela({ children }: { children: ReactNode }): React.JSX.Element {
  /**
   * O respiro entre os cartões mora aqui, e não em cada um.
   *
   * Empilhados sem folga eles se encostavam e viravam um bloco só — a tela
   * parecia uma tabela comprida em vez de assuntos separados. Pôr a margem em
   * cada cartão daria a mesma aparência com o dobro de lugares para esquecer.
   */
  return (
    <div className="min-h-0 flex-1 space-y-4 overflow-y-auto p-5">{children}</div>
  );
}
